import { helper } from 'utils';
const { isDevelopment, isDebugMode } = helper;

const QA = {
  redirector: 'https://apps.facebook.com/686377914890015?fb_source=237',
  fileHost: 'https://d2zqqna63nq7gm.cloudfront.net/',
  payment: {
    env: 'int',
    merchantSiteId: '239288',
    merchantId: '2745314597010947491',
    sdk: 'https://cdn.safecharge.com/safecharge_resources/v1/checkout/checkout.js',
  },
  api: {
    login: 'https://api-es-qa1.bbum-spades.com/login',
    store: 'https://api-es-qa1.bbum-spades.com/ims',
    purchaseInvoice: 'https://api-es-qa1.bbum-spades.com/createPurchaseInvoice',
    invoiceStatus: 'https://api-es-qa1.bbum-spades.com/getPurchaseInvoice',
    claimDynamicBonus: 'https://api-es-qa1.bbum-spades.com/claimDynamicBonus',
  },
  fb: {
    appId: '686377914890015',
    redirectUri: isDevelopment ? 'http://localhost:3000/login' : 'https://estore-qa1.bbum-spades.com/login',
    sdk: 'https://connect.facebook.net/en_US/sdk/debug.js',
  },
  info: {
    gameName: 'spades',
    privacyPolicy: 'https://www.bbumgames.com/privacy-policy',
    termsConditions: 'https://www.bbumgames.com/terms-of-service',
    contactSupport: 'https://fb.spadesroyale.com/support.html',
    socials: {
      facebook: 'https://www.facebook.com/spadesroyale',
      instagram: 'https://www.instagram.com/spades_royale',
      x: 'https://x.com/spades_royale',
    },
  },
};

const PROD = {
  redirector: 'https://apps.facebook.com/686377914890015?fb_source=237',
  fileHost: 'https://d27arutwwr0bum.cloudfront.net/',
  payment: {
    env: 'prod',
    merchantSiteId: '239288',
    merchantId: '2745314597010947491',
    sdk: 'https://cdn.safecharge.com/safecharge_resources/v1/checkout/checkout.js',
  },
  api: {
    login: 'https://api-es.bbumgames.com/login',
    store: 'https://api-es.bbumgames.com/ims',
    purchaseInvoice: 'https://api-es.bbumgames.com/createPurchaseInvoice',
    invoiceStatus: 'https://api-es.bbumgames.com/getPurchaseInvoice',
    claimDynamicBonus: 'https://api-es.bbumgames.com/claimDynamicBonus',
  },
  fb: {
    appId: '1765185660437581',
    redirectUri: 'https://game-hub.bbumgames.com/login',
    sdk: 'https://connect.facebook.net/en_US/sdk.js',
  },
  info: {
    gameName: 'spades',
    privacyPolicy: 'https://www.bbumgames.com/privacy-policy',
    termsConditions: 'https://www.bbumgames.com/terms-of-service',
    contactSupport: 'https://fb2.bbumgames.com/support_m.html',
    socials: {
      facebook: 'https://www.facebook.com/Backgammon.LOTB',
      instagram: 'https://www.instagram.com/lordoftheboard_official',
      x: 'https://x.com/Lordoftheboard3',
    },
  },
};

export default isDebugMode ? QA : PROD;
